/**
 * Client-side gate for Admin Sync Operations UI (Epic 4 Story 4.1).
 * Mirrors backend ADMIN_SYNC_OPS_ENABLED — fail closed.
 */

function parseEnvFlag(value) {
  return String(value || 'false').trim().toLowerCase() === 'true';
}

/**
 * @returns {boolean}
 */
export function isAdminSyncOpsUiEnabled() {
  return parseEnvFlag(process.env.REACT_APP_ADMIN_SYNC_OPS_ENABLED);
}
